<script setup>
// Divide um formulário longo em etapas navegáveis. As etapas continuam montadas (v-show no
// consumidor), então trocar de aba não perde o que já foi digitado.
defineProps({
  steps: {
    type: Array,
    required: true,
    validator: value => value.every(step => 'value' in step && 'label' in step),
  },
  modelValue: { type: [String, Number], required: true },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex items-center gap-1 p-1 rounded-lg bg-n-alpha-1 w-fit">
    <button
      v-for="(step, index) in steps"
      :key="step.value"
      type="button"
      class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-md transition-colors"
      :class="
        modelValue === step.value
          ? 'bg-n-solid-1 text-n-slate-12 font-medium shadow-sm'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="emit('update:modelValue', step.value)"
    >
      <span
        class="grid text-xs rounded-full size-5 place-content-center"
        :class="
          modelValue === step.value
            ? 'bg-n-brand text-white'
            : 'bg-n-alpha-2 text-n-slate-11'
        "
      >
        {{ index + 1 }}
      </span>
      {{ step.label }}
    </button>
  </div>
</template>
